import { ForwardedRef, forwardRef, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Swiper } from "swiper/types";
import { IconNames } from "../../stories/Foundation/Icons";
import { ButtonTypes } from "../../stories/Components/Button/interface";
import Button from "../../stories/Components/Button";
import Navigation from "../../stories/Components/Navigation";
import Slider from "../../stories/Components/Slider";
import VideoModal from "../VideoModal";
import { PlaylistCoreProps } from "./interface";
import classes from "./playlistCore.module.scss";

const LeftButton = forwardRef((props, ref: ForwardedRef<HTMLButtonElement>) => (
    <Button
        type={ButtonTypes.IconButton}
        label="Previous Video"
        name={IconNames.Left}
        background={true}
        ref={ref}
        {...props}
    />
));

const RightButton = forwardRef(
    (props, ref: ForwardedRef<HTMLButtonElement>) => (
        <Button
            type={ButtonTypes.IconButton}
            label="Next Video"
            name={IconNames.Right}
            background={true}
            ref={ref}
            {...props}
        />
    )
);

const PlaylistCore = ({
    cardData,
    title,
    navigationLinks,
    handleClose,
    playingVideoIndex,
    modalIsOpen,
    onSlideChange,
    onModalSwiper = () => null,
    onWidgetSwiper = () => null,
    aspectRatio,
    featureAttributionName,
    shouldDisableAds = false,
    autoplayNextOnVideoEnd = true,
    children,
}: PlaylistCoreProps) => {
    const leftRef = useRef<HTMLButtonElement>(null);
    const rightRef = useRef<HTMLButtonElement>(null);

    /* eslint-disable */
    const [modalSwiperObject, setModalSwiperObject] = useState<Swiper | null>(
        null
    );
    const videoPlaybackStatus: string = useSelector(
        (state: any) => state.persistentPlayer.status
    );
    /* eslint-enable */

    useEffect(() => {
        if (
            autoplayNextOnVideoEnd &&
            modalSwiperObject &&
            videoPlaybackStatus === "ended"
        ) {
            modalSwiperObject.slideNext(); // eslint-disable-line
        }
    }, [modalSwiperObject, videoPlaybackStatus, autoplayNextOnVideoEnd]);

    return (
        <div className={classes.playlistCore}>
            <div className={classes.headingRow}>
                <h2 className={classes.heading}>{title}</h2>
                <div className={classes.buttonsWrapper}>
                    <LeftButton ref={leftRef} />
                    <RightButton ref={rightRef} />
                </div>
            </div>
            {navigationLinks &&
                navigationLinks.links &&
                navigationLinks.links.length && (
                    <Navigation {...navigationLinks} />
                )}
            <Slider
                freemode={true}
                customControls={{
                    rightButtonRef: rightRef,
                    leftButtonRef: leftRef,
                }}
                onSwiper={onWidgetSwiper}
            >
                {children}
            </Slider>

            <VideoModal
                isOpen={modalIsOpen}
                items={cardData}
                onSlideChange={onSlideChange}
                onSwiper={setModalSwiperObject}
                handleClose={handleClose}
                playingVideoIndex={playingVideoIndex}
                aspectRatio={aspectRatio}
                featureAttributionName={featureAttributionName}
                shouldDisableAds={shouldDisableAds}
            />
        </div>
    );
};

export default PlaylistCore;
